(function(){
    'use strict';
    angular.module('app').controller('PreviewModalController', PreviewModalController);

    PreviewModalController.$inject = [
        '$uibModalInstance',
        '$q',
        'clientServiceData',
        'recipients',
        'toastr',
        'cc',
        'CarrierLoadRatesTableService',
        'ClientService',
        'LoadingModalFactory',
        'ServicesService',
        'ServiceProfile'
    ];

    function PreviewModalController(
        $uibModalInstance,
        $q,
        clientServiceData,
        recipients,
        toastr,
        cc,
        CarrierLoadRatesTableService,
        ClientService,
        LoadingModalFactory,
        ServicesService,
        ServiceProfile
    ) {
        let vm = this;
        vm.serviceProfile = [];
        vm.close = close;
        vm.sendRateCard = sendRateCard;
        vm.recipients = recipients,
        vm.cc = cc;
        vm.margin = {};
        vm.sent = false;
        init();

        function init() {
            getClientServiceProfile().then(data=>{
                vm.margin.fixed = data.marginMinValue;
                vm.margin.percent = data.marginPercent;
                vm.serviceProfile = data.serviceProfile;
                getRatesWithMargin(data.serviceProfile);

                vm.noRates = true;
                angular.forEach(ServiceProfile.service.rateCategories, function(value){
                    if(value.table.data.length !== 0) {
                        vm.noRates = false;
                    }
                });
            });
        }

        function getRatesWithMargin(serviceProfile) {
            if(angular.getObjVal(serviceProfile, 'service.rateCategories')) {
                angular.forEach(serviceProfile.service.rateCategories, rateType=>{
                    let table = new CarrierLoadRatesTableService(angular.copy(serviceProfile), {
                        isPreview: true, 
                        rateType, 
                        margin: vm.margin,
                        fixedHeight: true
                    });
                    rateType.table = table.tableData;
                });
            }
        }

        function close() {
            $uibModalInstance.close(vm.sent);
        }

        function sendRateCard() {
            if(vm.recipients.length !== 0 && !vm.isSending) {
                let payload = {
                    recipients: vm.recipients.map(email=>{
                        return email.label;
                    }),
                    cc: vm.cc.length !== 0 ? vm.cc.map(email=>{
                        return email.label;
                    }) : []
                };
                vm.isSending = true;
                ClientService.Client.sendPreview(payload, function(data){
                    vm.sent = true;
                    vm.isSending = false;
                    toastr.success('Email successfully sent', 'SUCCESS');
                    $uibModalInstance.close(vm.sent);
                }, function(error){
                    toastr.error(error.message, error.code);
                    vm.isSending = false;
                }, clientServiceData.id);
            } else {
                toastr.warning('Please add a recipient.', 'FORM ERROR');
            }
        }

        function getClientServiceProfile() {
            const defer = $q.defer();
            ServicesService.getClientServiceLink(clientServiceData.id, function (data) {
                defer.resolve(data);
            }, function (err) {
                defer.reject(err);
                toastr.error('Client Service Profile not found', '404');
            });
            return defer.promise;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/controllers/services/add-ons/PreviewModalController.js